/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Table, Tag, Modal, Space, Button, Tooltip } from 'antd';
import { format } from 'date-fns';
import { plusicon, refreshicon, searchnormal } from '../imagepath';
import { Link } from 'react-router-dom';
import { useBranchList } from '../../hooks/branches/useBranchList';
import { useUserClinic } from '../../hooks/useUserClinic';
import AddBranch from './AddBranch';
import EditBranch from './EditBranch';
import { useUserLocale } from '../../hooks/useLocale';
import { APP_TERMS } from '../../app-terms';
import { AvailableAppLocales } from '../../availableAppLocales';
import useDebounce from '../../hooks/useDebounce';
import { useDidUpdateEffect } from '../../hooks/useDidUpdateEffect';
import BreadCrumbs from '../core/BreadCrumbs';
import {EditOutlined } from '@ant-design/icons';
const BREAD_CRUMBS = [
  { label: 'Clinic', to: '/user/branchlist' },
  { label: 'List', to: '/user/branchlist' },
];
const BranchList = () => {
  const formRef = useRef(null);
  const [search, setSearch] = useState();
  const [searchString, setSearchString] = useState();
  const [loadingList, setLoadingList] = useState(true);
  const { userLocale } = useUserLocale();
  const { userClinic } = useUserClinic();
  const { data, getBranchList } = useBranchList();
  const [show, setShow] = useState(false);
  const [editRecord, setEditRecord] = useState();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  // Search string
  const pauseAndRestart = useDebounce(() => setSearch(searchString));
  useDidUpdateEffect(pauseAndRestart, [searchString]);

  // modal
  const showModal = () => {
    formRef?.current?.reset?.();
    setShow(true);
  };
  const hideModal = () => {
    !editRecord ? formRef?.current?.reset?.() : null;
    setShow(false);
    setEditRecord(undefined);
  };
  const handleCancel = () => {
    hideModal();
  };
  const handleSuccess = () => {
    hideModal();
    reload();
  };
  const handleError = () => {};

  // Table
  const handleAdd = () => showModal();
  const handleEdit = (record) => {
    showModal();
    setEditRecord(record);
  };
  const reload = useCallback(async () => {
    setLoadingList(true);
    try {
      const response = await getBranchList({
        search,
        page: tableParams.pagination?.current,
        limit: tableParams.pagination?.pageSize,
        clinicId: userClinic?.clinicId,
        sortOrder: tableParams?.sortOrder,
        sortBy: tableParams?.sortField,
      });
      setLoadingList(false);
      // Update table params
      setTableParams({
        ...tableParams,
        pagination: {
          ...tableParams.pagination,
          total: response.totalItems,
          // 200 is mock data, you should read it from server
          // total: data.totalCount,
        },
      });
    } catch (error) {
      setLoadingList(false);
    }
  }, [
    userClinic?.clinicId,
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    search,
  ]);
  const handleTableChange = (pagination, _, sorter) => {
    setTableParams({
      pagination,
      sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
      sortField: Array.isArray(sorter) ? undefined : sorter.field,
    });
  };
  const onActionItemClick = ({ key }, record) => {
    switch (key) {
      case 'Edit':
        handleEdit(record);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    reload();
  }, [
    userClinic?.clinicId,
    tableParams.pagination?.current,
    tableParams.pagination?.pageSize,
    tableParams?.sortOrder,
    tableParams?.sortField,
    search,
  ]);
  const columns = [
    {
      title: 'No.',
      render: (_, __, index) => index + 1,
    },
    {
      title: 'Clinic Name',
      dataIndex: 'clinicLocationTitle',
    },
    {
      title: 'Clinic Location',
      dataIndex: 'address',
      sorter: true,
    },
    {
      title: 'Mobile',
      dataIndex: 'contactNumber',
      sorter: true,
    },
    {
      title: 'Total Users',
      dataIndex: 'totalUsers',
      sorter: true,
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (_, { status }, index) => {
        let color = status ? 'green' : 'geekblue';
        return (
          <Tag color={color} key={index}>
            {status ? 'Active' : 'In Active'}
          </Tag>
        );
      },
      sorter: true,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      render: (text) =>
        format(new Date(text), APP_TERMS.date_1_format, {
          locale: AvailableAppLocales?.[userLocale],
        }),
      sorter: true,
    },
    {
      title: '',
      dataIndex: '',
      render: (text, record) => (
        <Space size="middle">
          <Button key="ok" type="primary" onClick={() => handleEdit(record)}   icon={<EditOutlined />}/>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div>
        <div>
          {/* Page Header */}
          <BreadCrumbs items={BREAD_CRUMBS} />
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  onChange={(e) =>
                                    setSearchString(e?.target?.value)
                                  }
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="#" />
                                </Link>
                              </form>
                            </div>
                            <div className="add-group">
                              <Tooltip title={"Add New"}>
                                {/* <Link
                                  onClick={handleAdd}
                                  className="btn btn-primary add-pluss ms-2"
                                >
                                  <img src={plusicon} alt="#" />
                                </Link> */}
                                <Button
                                  type="primary"
                                  onClick={(e) => {
                                    e?.preventDefault();
                                    handleAdd();
                                  }}
                                  className="ms-2"
                                >
                                  ADD
                                  {/* <img src={plusicon} alt="#" /> */}
                                </Button>
                              </Tooltip>
                              {/* <Link
                                onClick={reload}
                                className="btn btn-primary doctor-refresh ms-2"
                              >
                                <img src={refreshicon} alt="#" />
                              </Link> */}
                              <Button
                                onClick={(e) => {
                                  e?.preventDefault();
                                  reload();
                                }}
                                className="ms-2"
                              >
                                Refresh
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Table Header */}
                  <div className="table-responsive doctor-list">
                    <Table
                      loading={loadingList}
                      onChange={handleTableChange}
                      pagination={tableParams.pagination}
                      // pagination={{
                      //   total: data?.totalItems,
                      //   showTotal: (total, range) =>
                      //     `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      //   itemRender: itemRender,
                      // }}
                      columns={columns}
                      dataSource={data?.items}
                      // rowSelection={rowSelection}
                      rowKey={(record) => record.clinicLocationId}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        title={editRecord ? 'Edit' : 'Add'}
        open={show}
        onCancel={handleCancel}
        maskClosable={false}
        footer={null}
      >
        {editRecord ? (
          <EditBranch
            ref={formRef}
            formValues={editRecord ?? {}}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        ) : (
          <AddBranch
            ref={formRef}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        )}
      </Modal>
    </>
  );
};

export default BranchList;
